import Sidebar from "../components/sidebar/side"
import Projects from "../components/projects/proejcts";
import Vistor from "../components/visitor/vistor"
import MyCalendar from "../components/clender/clender";
import Team from "../components/team/team"
import Project from "../components/project/project"
import Table from "../components/table/table"
import Marketing from "../components/marketing/marketing"
function Projectreportt(){
    return(
        <>
   <Sidebar/>
   <Projects/>
        <Vistor/>
        <MyCalendar/>
        <Team/>
        <Project/>
        <Table/>
        <Marketing/>              

        </>
    )
}
export default Projectreportt